import React, {useEffect, useState} from "react";
import queryString, { parse } from 'query-string';
import history from "../../history";
import raportorSecimListesi from "../../services/raportorSecimListesi";
import raportorleriGuncelle from "../../services/raportorleriGuncelle";
import addAtaEvent from "../../services/addAtaEvent";
import {Card,Row,Col,message,Spin,Form,Input,Select,Button,Tooltip as TooltipAnd} from 'antd';
import * as util from "../Helpers/Util";
import * as validation from "../BForm/validation";
const { Option } = Select;
const parsed = queryString.parse(history.location.search);
const formItemStyle = {
    marginLeft : 10
}
const formLayout = {
    labelCol : {
        span : 4
    },
    wrapperCol : {
        span : 8
    }
}
const RaportorAtaForm = () => {

    const [spining, setSpining] = useState(true);
    const [form] = Form.useForm();
    const[raportorList,setRaportorList] = useState([]);


    const loadForm = async () => {
        setSpining(true);
        var data = [];
        await raportorSecimListesi(parsed).then(resp => {
            if(resp.data.success){
                setRaportorList(resp.data.result);
                resp.data.result.map(elem => {
                    if(elem.sorumluKullaniciId > 0 ){
                        data[elem.raportorSecimKuralId] =  elem.sorumluKullaniciId;
                    }
                });
            }else{
                util.errorMessage(resp.data.message);
            }
        }).catch(ex => {
            util.errorMessage(String(ex.message));
        });
        form.setFieldsValue(data);
        setSpining(false);
    }
    useEffect(() => {
        loadForm();
    }, []);


    const onFinish = async(values) =>{
        setSpining(true);
        let validData = [];

        let raportorGuncelleRequest = {
            ParentBasvuruId : parseInt(parsed.parentObjectId),
            RaportorDetails : []
        };

        let ataEventRequest = {
            ParentBasvuruId :  parseInt(parsed.parentObjectId),
            AltSurecTipiIdList : []
        };

        await Object.keys(values).forEach(function(key) {  
            var raportor =  Object.values(raportorList).filter(r => r.raportorSecimKuralId == key)[0];
       
            if(!util.isNullOrEmptyOrUndefined(values[key])){                
                raportorGuncelleRequest.RaportorDetails.push({
                    RaportorSecimKuralId : key,
                    RaportorId :  parseInt(values[key])
                });               
            }

            ataEventRequest.AltSurecTipiIdList.push(raportor.raportorAltSurecTipiId);
            validData[raportor.raportorAltSurecTipiId] =  !util.isNullOrEmptyOrUndefined(values[key]) ? parseInt(values[key]) : null;
        });

        var secimKuralValidation = validation.raportorSecimKuralValidation(raportorList[0].secimKuralTuruId,validData);

        if(secimKuralValidation.succes){  // Raportör seçim kurallarda hata yoksa
            var raportorGuncelleResponse =  await raportorGuncelle(raportorGuncelleRequest); // Raportörlerin güncellenmesi
            if(raportorGuncelleResponse){
               ataEvent(ataEventRequest); // Seçilen süreçlere ataEvent eklenmesi
            }else{
                util.errorMessage("Seçilen raportör güncelleme işleminde hata alınmıştır.");
            }           
        }else{
            util.errorMessage(secimKuralValidation.message);
        } 

        setSpining(false);
       
    }
   
    const raportorGuncelle = async (data) => {
        var result = false;
        await raportorleriGuncelle(data).then(resp => {
            result = resp.data.success;
        });

         return result;
    }

    const ataEvent = (data) => {
        addAtaEvent(data).then(resp => {
            if(!resp.data.success){
                util.errorMessage(resp.data.message);
            }else{
                util.successMessage(resp.data.message);
                window.parent.parent.location.reload();
            }
        }).catch(ex => {
            util.errorMessage(String(ex.message));
        }); 
    }

    return(
        <Spin tip={"Veriler yükleniyor. Lütfen bekleyiniz."} spinning={spining}>
           <Card bodyStyle={{padding: "10",fontWeight:"bold"}}>
           {'Raportör Seçim Formu'}
           </Card> 
           <Form form={form}  {...formLayout} onFinish={onFinish}   initialValues={{ remember: true }}>
                {raportorList.map(key => ( 
                    <Form.Item key={key.raportorSecimKuralId} label={key.editorAdi} name={key.raportorSecimKuralId} style={formItemStyle}  labelAlign="left">
                        <Select
                            showSearch
                            allowClear
                            defaultValue=
                            {key.sorumluKullaniciId >0 ? key.sorumluKullaniciId : []}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                            {key.kullaniciList && key.kullaniciList.map(bt => <Option key={key.kullaniciKodu} value={bt.kullaniciKodu}>{bt.adSoyad}</Option>)}
                        </Select>
                    </Form.Item>
                ))}  
                <Row>
                    <Col span={12} style={{textAlign: 'right'}}>
                        <Button type="primary" htmlType="submit">
                            Raportör Atama
                        </Button>
                    </Col>  
                </Row>  
            </Form> 
         </Spin>
    );
}

export default RaportorAtaForm;